import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { serverURL } from "../components/networking";
import korotuLogo from "../resources/KorotuLogo.png";

export default function ResetPage() {
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    return (
        <div className="login-page">
            <div className="login-left">
                <div className="login-brand">
                    <img src={korotuLogo} alt="Korotu logo" />
                </div>
            </div>

            <div className="login-right">
                <PasswordResetForm
                    navigate={navigate}
                    setErrorMessage={setErrorMessage}
                    errorMessage={errorMessage}
                />
            </div>
        </div>
    );
}

function PasswordResetForm({ navigate, setErrorMessage, errorMessage }) {
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const location = useLocation();

    function resetPassword(code, email, password, passwordVerify) {
        if (
            password === passwordVerify &&
            password !== "" &&
            code !== "" &&
            email !== ""
        ) {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/reset-password/",
                    { email: email, password: password, code: code },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    navigate("/");
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else if (password !== passwordVerify) {
            setErrorMessage("Passwords don't match!");
        } else {
            setErrorMessage("No fields may be left blank!");
        }
    }

    return (
        <div className="login-card">
            <h2>Reset Password</h2>
            <p className="login-helper">
                If the email address you entered is associated with an account,
                you will receive a verification code. Please enter it below.
            </p>
            <div className="login-field">
                <label htmlFor="reset-code">Code</label>
                <input
                    id="reset-code"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
            </div>
            <div className="login-field">
                <label htmlFor="reset-password">New Password</label>
                <input
                    id="reset-password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <div className="login-field">
                <label htmlFor="reset-password-confirm">
                    Confirm New Password
                </label>
                <input
                    id="reset-password-confirm"
                    type="password"
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                />
            </div>
            <button
                type="button"
                onClick={() => {
                    const email = location.state.email;
                    resetPassword(code, email, password, password2);
                }}
            >
                Submit
            </button>
            <button
                type="button"
                className="login-secondary"
                onClick={() => {
                    setErrorMessage("");
                    navigate("/");
                }}
            >
                Return to Login
            </button>
            {errorMessage ? (
                <p className="error-message" role="alert">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}
